// Интерфейсы для данных разных языков
export interface LanguageData {
    navigation: {
        main: NavigationItem[];
        company: NavigationItem[];
        bottomBar: NavigationItem[];
        footer: FooterSection[];
    };
    content: {
        common: Record<string, string>;
        pages: Record<string, Record<string, string>>;
    };
    forms: {
        labels: Record<string, string>;
        placeholders: Record<string, string>;
        buttons: Record<string, string>;
        validation: Record<string, string>;
    };
}

export interface NavigationItem {
    name: string;
    url: string;
    icon?: string;
    iconType?: 'lucide' | 'image';
    badgeKey?: string;
}

export interface FooterSection {
    title: string;
    links: NavigationItem[];
}

// Данные для английского языка
export const enData: LanguageData = {
    navigation: {
        main: [
            { url: '/shop', name: 'Electronics' },
            { url: '/jewelry', name: 'Jewelry' }
        ],
        company: [
            { url: '/about', name: 'About Us' },
            { url: '/contacts', name: 'Contacts' }
        ],
        bottomBar: [
            { name: 'home', url: '/', icon: 'Home', iconType: 'lucide' },
            { name: 'services', url: '/services', icon: 'Factory', iconType: 'lucide' },
            { name: 'catalog', url: '#catalog-modal', icon: 'Grid3x3', iconType: 'lucide' },
            { name: 'cart', url: '/shop/cart', icon: 'ClipboardList', iconType: 'lucide', badgeKey: 'cart' },
            { name: 'contacts', url: '/company/contacts', icon: 'Phone', iconType: 'lucide' }
        ],
        footer: [
            {
                title: 'Product',
                links: [
                    { name: 'Overview', url: '#' },
                    { name: 'Pricing', url: '#' },
                    { name: 'Marketplace', url: '#' },
                    { name: 'Features', url: '#' },
                    { name: 'Integrations', url: '#' }
                ]
            },
            {
                title: 'Company',
                links: [
                    { name: 'About', url: '/about' },
                    { name: 'Team', url: '/team' },
                    { name: 'Blog', url: '/blog' },
                    { name: 'Careers', url: '/careers' },
                    { name: 'Contact', url: '/contacts' },
                    { name: 'Privacy', url: '/lega/privacy' }
                ]
            }
        ]
    },
    content: {
        common: {
            loading: 'Loading...',
            error: 'Error',
            success: 'Success',
            cancel: 'Cancel',
            save: 'Save',
            delete: 'Delete',
            edit: 'Edit',
            add: 'Add',
            search: 'Search',
            filter: 'Filter',
            sort: 'Sort',
            viewAll: 'View All',
            showMore: 'Show More',
            readMore: 'Read More',
            currency: 'USD',
            currencySymbol: '$',
            home: 'Home',
            services: 'Services',
            catalog: 'Catalog',
            cart: 'Cart',
            contacts: 'Contacts',
            profile: 'Profile'
        },
        pages: {
            home: {
                title: 'Welcome to WebGoodPeople',
                subtitle: 'Professional e-commerce solutions',
                heroText: 'Build your dream online store'
            },
            shop: {
                title: 'Shop',
                subtitle: 'Discover amazing products',
                noProducts: 'No products found'
            }
        }
    },
    forms: {
        labels: {
            email: 'Email',
            password: 'Password',
            confirmPassword: 'Confirm Password',
            firstName: 'First Name',
            lastName: 'Last Name',
            phone: 'Phone',
            address: 'Address'
        },
        placeholders: {
            email: 'Enter your email',
            password: 'Enter your password',
            search: 'Search products...',
            phone: 'Enter phone number'
        },
        buttons: {
            login: 'Login',
            register: 'Register',
            logout: 'Logout',
            submit: 'Submit',
            addToCart: 'Add to Cart',
            buyNow: 'Buy Now',
            checkout: 'Checkout'
        },
        validation: {
            required: 'This field is required',
            invalidEmail: 'Invalid email address',
            passwordMismatch: 'Passwords do not match',
            minLength: 'Minimum length is {0} characters'
        }
    }
};

// Данные для русского языка
export const ruData: LanguageData = {
    navigation: {
        main: [
            { url: '/shop', name: 'Электроника' },
            { url: '/jewelry', name: 'Ювелирные украшения' }
        ],
        company: [
            { url: '/about', name: 'О нас' },
            { url: '/contacts', name: 'Контакты' }
        ],
        bottomBar: [
            { name: 'home', url: '/', icon: 'Home', iconType: 'lucide' },
            { name: 'services', url: '/shop/category/stroitelnye-raboty/', icon: 'Factory', iconType: 'lucide' },
            { name: 'catalog', url: '#catalog-modal', icon: 'Grid3x3', iconType: 'lucide' },
            { name: 'cart', url: '/shop/cart/', icon: 'ClipboardList', iconType: 'lucide', badgeKey: 'cart' },
            { name: 'contacts', url: '/company/contacts/', icon: 'Phone', iconType: 'lucide' }
        ],
        footer: [
            {
                title: 'Продукт',
                links: [
                    { name: 'Обзор', url: '#' },
                    { name: 'Цены', url: '#' },
                    { name: 'Маркетплейс', url: '#' },
                    { name: 'Функции', url: '#' },
                    { name: 'Интеграции', url: '#' }
                ]
            },
            {
                title: 'Компания',
                links: [
                    { name: 'О нас', url: '/about' },
                    { name: 'Команда', url: '/team' },
                    { name: 'Блог', url: '/blog' },
                    { name: 'Карьера', url: '/careers' },
                    { name: 'Контакты', url: '/contacts' },
                    { name: 'Конфиденциальность', url: '/privacy' }
                ]
            }
        ]
    },
    content: {
        common: {
            loading: 'Загрузка...',
            error: 'Ошибка',
            success: 'Успешно',
            cancel: 'Отмена',
            save: 'Сохранить',
            delete: 'Удалить',
            edit: 'Редактировать',
            add: 'Добавить',
            search: 'Поиск',
            filter: 'Фильтр',
            sort: 'Сортировка',
            viewAll: 'Показать всё',
            showMore: 'Показать ещё',
            readMore: 'Читать далее',
            currency: 'RUB',
            currencySymbol: '₽',
            home: 'Главная',
            services: 'Услуги',
            catalog: 'Каталог',
            cart: 'Заявка',
            contacts: 'Контакты',
            profile: 'Профиль'
        },
        pages: {
            home: {
                title: 'Добро пожаловать в WebGoodPeople',
                subtitle: 'Профессиональные решения для электронной коммерции',
                heroText: 'Создайте интернет-магазин своей мечты'
            },
            shop: {
                title: 'Магазин',
                subtitle: 'Откройте для себя удивительные товары',
                noProducts: 'Товары не найдены'
            }
        }
    },
    forms: {
        labels: {
            email: 'Электронная почта',
            password: 'Пароль',
            confirmPassword: 'Подтвердите пароль',
            firstName: 'Имя',
            lastName: 'Фамилия',
            phone: 'Телефон',
            address: 'Адрес'
        },
        placeholders: {
            email: 'Введите ваш email',
            password: 'Введите пароль',
            search: 'Поиск услуг и товаров...',
            phone: 'Введите номер телефона'
        },
        buttons: {
            login: 'Войти',
            register: 'Регистрация',
            logout: 'Выйти',
            submit: 'Отправить',
            addToCart: 'Добавить в заявку',
            buyNow: 'Заказать',
            checkout: 'Оформить заявку'
        },
        validation: {
            required: 'Это поле обязательно',
            invalidEmail: 'Неверный адрес электронной почты',
            passwordMismatch: 'Пароли не совпадают',
            minLength: 'Минимальная длина {0} символов'
        }
    }
};

// Данные для немецкого языка
export const deData: LanguageData = {
    navigation: {
        main: [
            { url: '/shop', name: 'Elektronik' },
            { url: '/jewelry', name: 'Schmuck' }
        ],
        company: [
            { url: '/about', name: 'Über uns' },
            { url: '/contacts', name: 'Kontakt' }
        ],
        bottomBar: [
            { name: 'home', url: '/', icon: 'Home', iconType: 'lucide' },
            { name: 'services', url: '/services', icon: 'Factory', iconType: 'lucide' },
            { name: 'catalog', url: '#catalog-modal', icon: 'Grid3x3', iconType: 'lucide' },
            { name: 'cart', url: '/shop/cart', icon: 'ClipboardList', iconType: 'lucide', badgeKey: 'cart' },
            { name: 'contacts', url: '/company/contacts', icon: 'Phone', iconType: 'lucide' }
        ],
        footer: [
            {
                title: 'Produkt',
                links: [
                    { name: 'Überblick', url: '#' },
                    { name: 'Preise', url: '#' },
                    { name: 'Marktplatz', url: '#' },
                    { name: 'Funktionen', url: '#' },
                    { name: 'Integrationen', url: '#' }
                ]
            },
            {
                title: 'Unternehmen',
                links: [
                    { name: 'Über uns', url: '/about' },
                    { name: 'Team', url: '/team' },
                    { name: 'Blog', url: '/blog' },
                    { name: 'Karriere', url: '/careers' },
                    { name: 'Kontakt', url: '/contacts' },
                    { name: 'Datenschutz', url: '/privacy' }
                ]
            }
        ]
    },
    content: {
        common: {
            loading: 'Laden...',
            error: 'Fehler',
            success: 'Erfolgreich',
            cancel: 'Abbrechen',
            save: 'Speichern',
            delete: 'Löschen',
            edit: 'Bearbeiten',
            add: 'Hinzufügen',
            search: 'Suchen',
            filter: 'Filter',
            sort: 'Sortieren',
            viewAll: 'Alle anzeigen',
            showMore: 'Mehr anzeigen',
            readMore: 'Weiterlesen',
            currency: 'EUR',
            currencySymbol: '€',
            home: 'Startseite',
            services: 'Dienstleistungen',
            catalog: 'Katalog',
            cart: 'Warenkorb',
            contacts: 'Kontakt',
            profile: 'Profil'
        },
        pages: {
            home: {
                title: 'Willkommen bei WebGoodPeople',
                subtitle: 'Professionelle E-Commerce-Lösungen',
                heroText: 'Bauen Sie Ihren Traum-Online-Shop'
            },
            shop: {
                title: 'Shop',
                subtitle: 'Entdecken Sie erstaunliche Produkte',
                noProducts: 'Keine Produkte gefunden'
            }
        }
    },
    forms: {
        labels: {
            email: 'E-Mail',
            password: 'Passwort',
            confirmPassword: 'Passwort bestätigen',
            firstName: 'Vorname',
            lastName: 'Nachname',
            phone: 'Telefon',
            address: 'Adresse'
        },
        placeholders: {
            email: 'Geben Sie Ihre E-Mail ein',
            password: 'Geben Sie Ihr Passwort ein',
            search: 'Produkte suchen...',
            phone: 'Telefonnummer eingeben'
        },
        buttons: {
            login: 'Anmelden',
            register: 'Registrieren',
            logout: 'Abmelden',
            submit: 'Senden',
            addToCart: 'In den Warenkorb',
            buyNow: 'Jetzt kaufen',
            checkout: 'Zur Kasse'
        },
        validation: {
            required: 'Dieses Feld ist erforderlich',
            invalidEmail: 'Ungültige E-Mail-Adresse',
            passwordMismatch: 'Passwörter stimmen nicht überein',
            minLength: 'Mindestlänge ist {0} Zeichen'
        }
    }
};

// Экспорт всех данных
export const languageData = {
    en: enData,
    ru: ruData,
    de: deData
}; 
